import { createAsyncThunk } from '@reduxjs/toolkit'
import { pixiResetRoulette, pixiStartRoulette, pixiStopRoulette } from './pixi-scripts/bridge'
import { getMyBetsRouletteService, placeBetRouletteGameService, rouletteCheckFairnessService } from './rouletteGame.service'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { delay, generateClientSeed } from 'utils/common-functions/index'
import { openErrorToaster } from 'utils/common-services/toaster.service'
import { getFreeBetDetail } from 'redux-store/thunk/crashGame.thunk'

export const placedBetRouletteGame = createAsyncThunk('roulette-game/place-bet',
  async ({ payload, freeRoundData }, thunkApi) => {
    try {
      const res = await placeBetRouletteGameService(payload)
      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }
      if (res?.winningNumber !== undefined && res?.winningNumber !== null) {
        pixiStartRoulette()
        await delay(1200)
        pixiStopRoulette(res.winningNumber)
      } else {
        pixiResetRoulette()
        throw new Error('Roulette result is missing a valid winning number')
      }
      freeRoundData && thunkApi.dispatch(getFreeBetDetail())
      return res
    } catch (error) {
      pixiResetRoulette()
      const errorMessage = Array.isArray(error) ? error?.[0]?.description : error?.description
      return thunkApi.rejectWithValue(errorMessage || 'Failed to place roulette bet')
    }
  }
)

export const getMyBetsRoulette = createAsyncThunk('roulette-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsRouletteService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const checkFairnessRouletteGame = createAsyncThunk('roulette-game/check-fairness', async (payload, thunkApi) => {
  try {
    const res = await rouletteCheckFairnessService(payload)
    return res
  } catch (error) {
    openErrorToaster({ message: error[0].description })
    return thunkApi.rejectWithValue(error[0].description)
  }
})
